function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as chatroomActions from './../chatroomActions';

import ImageForm from './../ImageForm/ImageForm';

export var MessageForm = function (_Component) {
    _inherits(MessageForm, _Component);

    function MessageForm(props) {
        _classCallCheck(this, MessageForm);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleChange = function (e) {
            var _this$setState;

            var _e$target = e.target,
                name = _e$target.name,
                value = _e$target.value;

            _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var message = _this.state.message;
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                uid = _this$props.uid,
                chatroomId = _this$props.chatroomId,
                chatroomUsers = _this$props.chatroomUsers;

            //We add the User to the list of users in the chatroom if he isn't in it already or init to empty

            if (!(uid in chatroomUsers) || chatroomUsers[uid]['username'] === '') {
                dispatch(chatroomActions.addUserToChat(chatroomId, uid));
            }

            if (message) {
                dispatch(chatroomActions.sendMessage(chatroomId, message, 'text'));
                _this.setState({ message: '' });
            }
        };

        _this.state = {
            message: ''
        };
        return _this;
    }

    MessageForm.prototype.render = function render() {
        var message = this.state.message;
        var isInProgress = this.props.isInProgress;

        return React.createElement(
            'form',
            { className: 'input', onSubmit: this.handleSubmit },
            React.createElement(
                'div',
                { className: 'input-container' },
                React.createElement(ImageForm, null),
                React.createElement(
                    'div',
                    { className: 'sendMessageContainer' },
                    React.createElement('input', { type: 'text',
                        name: 'message',
                        placeholder: 'Message',
                        value: message,
                        onChange: this.handleChange }),
                    React.createElement('input', { type: 'submit', value: 'Envoyer', disabled: isInProgress })
                )
            )
        );
    };

    return MessageForm;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    var isInProgress = state.chatroom.isInProgress;

    return {
        uid: state.auth.uid,
        chatroomId: state.chatroom.chatroomId,
        chatroomUsers: state.chatroom.users,
        isInProgress: isInProgress
    };
};

export default connect(mapStateToProps)(MessageForm);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/MessageForm/MessageForm.js
// module id = 221
// module chunks = 0